import { ItemTypes } from '~constants/ItemTypes';
import { IItem } from '~api/interfaces/IItem';
import { IParamsById } from '~api/interfaces/IParamsById';
import { IProductParams } from '~api/interfaces/IParams';

// Remove this method after full support of items key instead of paramsById
export const getItemsFromParamsById = (paramsById: IParamsById, featuredProductId?: string) => {
    const { productIds = [], skuIds = [] } = paramsById;
    const items: IItem[] = featuredProductId
        ? [{ type: ItemTypes.product, params: { id: featuredProductId, featured: true } }]
        : [];

    productIds.forEach((id) => {
        if (id !== featuredProductId) {
            items.push({ type: ItemTypes.product, params: { id } });
        }
    });
    skuIds.forEach((id) => {
        items.push({ type: ItemTypes.sku, params: { id } });
    });

    return items;
};

export const getProductsWithSkus = (products: IProductParams[]) => {
    return products.reduce(
        (skusArray: string[][], product: IProductParams) => {
            const { skusToDisplay = [], id } = product;
            if (skusToDisplay.length > 0) {
                skusArray[0].push(id);
                skusArray[1] = skusArray[1].concat(skusToDisplay);
            }

            return skusArray;
        },
        [[], []]
    );
};
